import { render, staticRenderFns } from "./depitByBus.vue?vue&type=template&id=327854ef&scoped=true&"
import script from "./depitByBus.vue?vue&type=script&lang=js&"
export * from "./depitByBus.vue?vue&type=script&lang=js&"
import style0 from "./depitByBus.vue?vue&type=style&index=0&id=327854ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327854ef",
  null
  
)

export default component.exports